import AppDispatcher from "../../../flux/dispatcher/dispatcher";
import Constant from "../constant/Constants";
import restClient from "../../MainFrame/action/APIClient";
import LogoutConstant from "../../MainFrame/constants/Constants";
var _ = require("lodash");

var ReviewRatingWaveChartAction = function () {};

ReviewRatingWaveChartAction.prototype = {
	getData: function (data) {
		restClient.getCompetitorReviewRating(data, function (error, response) {
			if (error) {
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error,
					});
				} else {
					AppDispatcher.dispatch({
						actionType: Constant.GET_REVIEW_VOLUME_AVERAGE_RATING,
						data: error,
					});
				}
			} else {
				response["status"] = 200;
				AppDispatcher.dispatch({
					actionType: Constant.GET_REVIEW_VOLUME_AVERAGE_RATING,
					data: response,
				});
			}
		});
	},
};

export default new ReviewRatingWaveChartAction();
